import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Company } from '../index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useSharedCapTableLinkDelete = () => {
  const queryClient = useQueryClient();
  const { selectedCompanyId: companyId } = Company.useSelected();

  const { isPending, mutate: deleteLink } = useAppMutation<unknown, unknown, { id: string }>(
    [QueryKey.SHARED_CAP_TABLE_LINK_DELETE, companyId],
    {
      mutationFn: ({ id }) =>
        ApiService.delete({
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'shared-cap-table-links', id],
        }),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryKey.SHARED_CAP_TABLE_LINKS] });
      },
    },
  );

  return { deleteLink, isPending };
};
